import { render } from "./vreferralcode.vue?vue&type=template&id=2e65baac&scoped=true"
import script from "./vreferralcode.vue?vue&type=script&lang=js"
export * from "./vreferralcode.vue?vue&type=script&lang=js"

import "./vreferralcode.vue?vue&type=style&index=0&id=2e65baac&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e65baac"]])

export default __exports__